import environment from '@/modules/cart/environments/environment';
import type { HttpCartPaymentsDto } from '@/modules/cart/infrastructure/dto/HttpCartPaymentsDto';
import httpClient from '@/modules/cart/services/api/client';

const { CART_URL } = environment;

export async function getBuyNowAlternativePayments(
  cartId: string
): Promise<{ data: HttpCartPaymentsDto }> {
  const url = `${CART_URL}/active-cart/alternative-payments`;
  const response = await httpClient.get<HttpCartPaymentsDto>(url, {
    headers: {
      'x-cart-id': cartId
    }
  });
  return response;
}
